import { render, staticRenderFns } from "./FrequentlyAskedQuestionByProgram.vue?vue&type=template&id=4dd453c0&scoped=true"
import script from "./FrequentlyAskedQuestionByProgram.vue?vue&type=script&lang=js"
export * from "./FrequentlyAskedQuestionByProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd453c0",
  null
  
)

export default component.exports